import React, { useState } from 'react';
import propTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

// Long owner written columns (description, disclaimer, lease agreement) get
// collapsed to a preview so they don't push the rest of the page out of reach.
// Kept as plain text with pre-wrap rather than HTML - the source is user input.
const ExpandableText = ({ text, limit = 200, className = 'preserve-formatting' }) => {
  const { t } = useTranslation();
  const [expanded, setExpanded] = useState(false);

  const value = typeof text === 'string' ? text : '';

  if (value.length <= limit) return <p className={className}>{value}</p>;

  // Cut on a word boundary when one sits near the limit, otherwise the preview
  // ends mid-word. Falling back to a hard cut covers text with no spaces.
  const slice = value.slice(0, limit);
  const lastSpace = slice.lastIndexOf(' ');
  const preview = lastSpace > limit * 0.6 ? slice.slice(0, lastSpace) : slice;

  return (
    <div>
      <p className={className}>{expanded ? value : `${preview.trimEnd()}...`}</p>
      <button
        type='button'
        className='bare-btn text-link mb-1'
        aria-expanded={expanded}
        onClick={() => setExpanded(!expanded)}
      >
        {expanded ? t('g_showLess') : t('g_showMore')}
      </button>
    </div>
  );
};

ExpandableText.propTypes = {
  text: propTypes.string,
  limit: propTypes.number,
  className: propTypes.string,
};

export default ExpandableText;
